export enum paymentReceipt {
    FACTURA = 1,
    BOLETA = 2,
}
export enum deliveryMethod {
    TIENDA = 0,
    ENVIO = 1
}

export enum orderStatus {
    GENERADO = 0,
    PENDIENTE = 1,
    ENVIADO = 2,
    ENTREGADO = 3,
    ANULADO = 4,
    CANCELADO = 5,
    CONFIRMADO = 6,
    RECOJO = 7,
}

export enum paymentMethodOrder {
    TRANSF_BANCARIA = 1,
    TARJETA_CREDITO = 2,
    YAPE = 3
}

export enum OrderStatusCancelled {
    OrderCancelledOne = 1,
    OrderCancelledTwo = 2,
    OrderCancelledThree = 3
}
